import classNames from 'classnames';
import React, {
  useEffect,
  useRef,
  useContext,
} from 'react';
import AnimateHeight from 'react-animate-height';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import useResizeObserver from 'use-resize-observer';

import { Icon } from '@powdr/components';
import { AppContext } from '@powdr/context';
import { getAlerts } from '@powdr/stores';

import { StyledAlertBar } from './styles';

export const AlertBar = () => {
  const dispatch = useDispatch();
  const useHeaderAlertData = useSelector((state) => state.alerts.headerAlert);
  const { data: headerAlert } = useHeaderAlertData;
  const {
    closedAlert,
    setClosedAlert,
    setAlertHeight,
  } = useContext(AppContext);
  const alertBarRef = useRef(null);
  const { height } = useResizeObserver({ ref: alertBarRef });

  useEffect(() => {
    dispatch(getAlerts({ headerAlert: true }));
  }, [dispatch]);

  useEffect(() => {
    setAlertHeight(height ?? 0);
  }, [height, setAlertHeight]);

  if (!headerAlert || closedAlert) {
    return null;
  }

  return (
    <StyledAlertBar
      className="alert-bar"
      $alertType={headerAlert.type}
      ref={alertBarRef}
    >
      <AnimateHeight duration={500} height="auto">
        <div className="alert-content-wrapper">
          <div className={classNames('alert-content')}>
            <div className="alert-html">
              {ReactHtmlParser(headerAlert?.message)}
            </div>

            <button
              type="button"
              onClick={() => setClosedAlert(true)}
              className="close"
              title="Close Alert Bar"
              aria-label="Close Alert Bar"
            >
              <Icon
                name="ui-close-circle"
                width="36"
                height="36"
              />
            </button>
          </div>
        </div>
      </AnimateHeight>
    </StyledAlertBar>
  );
};

AlertBar.propTypes = {};
